import { reduxKey } from './constants';
export var getIsPollSubmitting = function (state) {
    return state[reduxKey] && state[reduxKey].isSubmitting;
};
//# sourceMappingURL=selectors.js.map